import { handleActions } from 'redux-actions';
import { Actions } from '../constants';

export const initialState = {};

const reducer = handleActions(
  {
    [Actions.PLAY_EXPERIMENT]: (state, { payload: name }) => ({
      ...state,
      [name]: true,
    }),
  },
  initialState,
);

export default reducer;
